import { theme } from '@zappyrent/hundop';
import { upperFirst } from 'lodash';
// import { useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { UseMutateAsyncFunction } from 'react-query';
import { useParams } from 'react-router-dom';

import { SurveyAnswerDto } from '../../../types/survey';
import SurveyErrorMessage from '../SurveyErrorMessage';
import SurveyScore from '../SurveyScore/SurveyScore';
import {
  FormLabel,
  StyledBodyContainer,
  StyledButton,
  StyledButtonWrapper,
  StyledFormContainer,
  StyledSpinner,
  StyledTextArea,
} from './SurveyForm.styles';
import { SurveyAnswerForm } from './SurveyForm.types';

const SurveyForm = ({
  mutateAsync,
  isLoading,
}: {
  mutateAsync: UseMutateAsyncFunction<
    number,
    unknown,
    { id: string; data: SurveyAnswerDto },
    unknown
  >;
  isLoading: boolean;
}) => {
  const { surveyId } = useParams();
  const { t } = useTranslation(['survey']);
  const { control, formState, handleSubmit, watch } =
    useForm<SurveyAnswerForm>();

  const defaultFormErrorLabel = upperFirst(t('survey:surveyErrorMessage'));

  const [gradeValue, answerValue] = watch(['grade', 'answer_1']);

  const handleFormSubmit = async (data: SurveyAnswerForm) => {
    try {
      mutateAsync({
        data,
        id: surveyId as string,
      });
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <StyledBodyContainer>
      <form
        id="survey-answer-form"
        onSubmit={handleSubmit(handleFormSubmit)}
        noValidate
      >
        <StyledFormContainer>
          <FormLabel>
            {upperFirst(t('survey:surveyRecommendScoreText'))}
          </FormLabel>
          <SurveyScore control={control} formState={formState} />
          <FormLabel>
            {upperFirst(t('survey:surveyRecommendDescText'))}
          </FormLabel>
          <Controller
            control={control}
            name="answer_1"
            rules={{
              validate: {
                required: () => {
                  if (gradeValue <= 8 && !answerValue) {
                    return defaultFormErrorLabel;
                  }
                  return true;
                },
              },
            }}
            render={({ field: { onChange }, fieldState: { error } }) => (
              <div>
                <StyledTextArea
                  rows={5}
                  placeholder={upperFirst(
                    t('survey:surveyRecommendDescPlaceholderText'),
                  )}
                  onChange={onChange}
                />
                {formState.errors.answer_1 && (
                  <SurveyErrorMessage message={error?.message || ''} />
                )}
              </div>
            )}
          />
          <StyledButtonWrapper>
            <StyledButton user={'landlord'} type="submit" disabled={isLoading}>
              {isLoading && (
                <StyledSpinner
                  foregroundColor={theme.colors.cross.ultralightGray}
                  size={15}
                  strokeSize={2}
                />
              )}
              {upperFirst(t('common:send'))}
            </StyledButton>
          </StyledButtonWrapper>
        </StyledFormContainer>
      </form>
    </StyledBodyContainer>
  );
};

export default SurveyForm;
